import React, { useEffect, useState } from "react";
import { company, whatsappUrl } from "../data/companyData";
import CustomerSupportChatbot from "./CustomerSupportChatbot";
import "./styles/FloatingContactButtons.css";

/**
 * Floating action stack. Collapsed to a single trigger until tapped, so it
 * never fights the content on small screens.
 */
const FloatingContactButtons = () => {
  const [chatOpen, setChatOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [lifted, setLifted] = useState(false);

  /* Reveal the stack only once the hero is behind us */
  useEffect(() => {
    const onScroll = () => setLifted(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const actions = [
    {
      key: "chat",
      icon: "fas fa-comment-dots",
      label: "Ask our AI assistant",
      className: "fab--chat",
      onClick: () => {
        setChatOpen(true);
        setExpanded(false);
      },
    },
    {
      key: "whatsapp",
      icon: "fa-brands fa-whatsapp",
      label: "Message us on WhatsApp",
      className: "fab--wa",
      href: whatsappUrl,
    },
    {
      key: "call",
      icon: "fas fa-phone",
      label: `Call ${company.phones.office.display}`,
      className: "fab--call",
      href: `tel:${company.phones.office.tel}`,
    },
  ];

  return (
    <>
      <div className={`fabs${lifted ? " is-visible" : ""}${expanded ? " is-open" : ""}`}>
        {/* `inert` keeps the collapsed actions out of the tab order and the
            accessibility tree, since they are only visually hidden. */}
        <div className="fabs__stack" inert={!expanded}>
          {actions.map((a, i) =>
            a.href ? (
              <a
                key={a.key}
                href={a.href}
                className={`fab ${a.className}`}
                style={{ "--i": i }}
                aria-label={a.label}
                title={a.label}
                target={a.href.startsWith("http") ? "_blank" : undefined}
                rel={a.href.startsWith("http") ? "noreferrer" : undefined}>
                <i className={a.icon} aria-hidden="true" />
                <span className="fab__tip">{a.label}</span>
              </a>
            ) : (
              <button
                key={a.key}
                type="button"
                className={`fab ${a.className}`}
                style={{ "--i": i }}
                aria-label={a.label}
                title={a.label}
                onClick={a.onClick}>
                <i className={a.icon} aria-hidden="true" />
                <span className="fab__tip">{a.label}</span>
              </button>
            )
          )}
        </div>

        <button
          type="button"
          className="fab fab--trigger"
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
          aria-label={expanded ? "Close contact options" : "Open contact options"}>
          <i className={expanded ? "fas fa-xmark" : "fas fa-headset"} aria-hidden="true" />
          <span className="fab__pulse" aria-hidden="true" />
        </button>
      </div>

      <CustomerSupportChatbot isOpen={chatOpen} onClose={() => setChatOpen(false)} />
    </>
  );
};

export default FloatingContactButtons;
